/**
 * The chat message the Add a blog dialog sends once the blog is on. It is the one message the server
 * recognises as blog work by its shape, so the design check never depends on the model noticing it.
 */
export function blogAddRequest(choice: { name: string; base: string; menu: boolean; latest: boolean }): string {
  return `Design my new ${choice.name} blog at ${choice.base}: a list of posts, a post page, and tag pages. ${choice.menu ? "Keep its menu link." : "Leave it out of the menu."} ${choice.latest ? "Show the three latest posts on Home." : "Do not add a latest posts section on Home."}`;
}

/** Whether a message is the Add a blog dialog's own request. */
export function isBlogAddRequest(text: string): boolean {
  return /^Design my new .{1,80} blog at \/[^\s:]*: a list of posts, a post page, and tag pages\. (?:Keep its menu link|Leave it out of the menu)\. (?:Show the three latest posts on Home|Do not add a latest posts section on Home)\.$/.test(text.trim());
}
